// Every prerendered page. Titles, descriptions and labels live in locales/<code>/ui.json under meta.<slug>.*.
// Used by App (routing, nav) and scripts/prerender.mjs (HTML files per locale, canonical URLs, sitemap, llms.txt).
export interface Route { path: string; file: string; slug: string; nav: boolean }

export const routes: Route[] = [
  { path: '/', file: 'index.html', slug: 'home', nav: false },
  { path: '/setup', file: 'setup.html', slug: 'setup', nav: false },
  { path: '/when', file: 'when.html', slug: 'when', nav: true },
  { path: '/free-software', file: 'free-software.html', slug: 'free-software', nav: true },
  { path: '/grants', file: 'grants.html', slug: 'grants', nav: false },
  { path: '/how-it-works', file: 'how-it-works.html', slug: 'how-it-works', nav: true },
  { path: '/pos-and-retail', file: 'pos-and-retail.html', slug: 'pos-and-retail', nav: true },
  { path: '/faq', file: 'faq.html', slug: 'faq', nav: true },
  { path: '/links', file: 'links.html', slug: 'links', nav: false },
  { path: '/about', file: 'about.html', slug: 'about', nav: false },
  { path: '/changelog', file: 'changelog.html', slug: 'changelog', nav: false },
]

export const routeFor = (path: string) => routes.find(r => r.path === (path.replace(/\/$/, '') || '/'))

/** Which page each section id lives on, so links can be written as to('calculator') → "/when#calculator". */
export const sectionPage = {
  'what-is-invoicenow': '/', 'what-to-do': '/', events: '/', question: '/',
  steps: '/setup', login: '/setup',
  timeline: '/when', calculator: '/when',
  grants: '/grants', 'grant-faq': '/grants', 'free-package': '/free-software', 'software-check': '/free-software', 'find-vendor': '/free-software', foc: '/free-software', choose: '/free-software',
  how: '/how-it-works', 'what-you-need': '/how-it-works', 'peppol-id': '/how-it-works',
  pos: '/pos-and-retail',
  faq: '/faq',
} as const
export type SectionId = keyof typeof sectionPage
export const to = (id: SectionId) => `${sectionPage[id] === '/' ? '/' : sectionPage[id]}#${id}`

/** Which page(s) a ui key belongs to, for review grouping and per-page publishing: one path, several joined by commas,
 *  or '*' for every page. */
export function uiKeyPage(key: string): string {
  const [a, b] = key.split('.')
  if (a === 'meta' || a === 'head') return b === 'home' ? '/' : b === 'notfound' ? '*' : `/${b}`
  const map: Record<string, string> = {
    common: '*', cite: '*', banner: '*', i18n: '*', nav: '*', footer: '*', notfound: '*', until: '*',
    welcome: '/', hero: '/', intro: '/', explore: '/', checklist: '/,/setup', setup: '/setup', events: '/', question: '/',
    timeline: '/when', calc: '/when',
    grants: '/grants', software: '/free-software', vendor: '/free-software', next: '/free-software',
    how: '/how-it-works', need: '/how-it-works', peppol: '/how-it-works', flow: '/how-it-works',
    faq: '/faq', links: '/links', about: '/about', changelog: '/changelog',
  }
  return map[a] ?? '*'
}
